import request from '@/util/request';
import qs from 'qs';

export const getGroupList = (params, options) =>
  request.get('/api/v4ward/group/getGroupList', Object.assign({}, options, { params }));

export const getList = (params, options) =>
request.get('/api/v4ward/out/order/setting/page', Object.assign({}, options, { params }));

export const getProjectList = (params, options) =>
  request.get('api/v4ward/project/getProjectList', Object.assign({}, options, { params }));


export const getDetail = (params, options) =>
request.get('/api/v4ward/out/order/setting/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/out/order/setting/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/out/order/setting/submit', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/out/order/setting/submit', params,options);

export const saveOrderSettingFlow = (params, options) =>
request.post('/api/v4ward/out/order/setting/update', params,options);

export const changeOrderSettingStatus = (params, options) =>
  request.post('/api/v4ward/out/order/setting/changeStatus', params,options);


// 字典
export const getDictionary = (params, options) =>
request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }))
